var exports = {
  "nM": "CrosspostPublishNudge.module__row___elgxZD",
  "Io": "CrosspostPublishNudge.module__pill___elgxZD",
  "Kk": "CrosspostPublishNudge.module__icon___elgxZD",
  "Pf": "CrosspostPublishNudge.module__label___elgxZD",
  "_4": "CrosspostPublishNudge.module__publishButton___elgxZD",
  "r": "CrosspostPublishNudge.module__dismissButton___elgxZD",
  "EL": "CrosspostPublishNudge.module__hideForeverButton___elgxZD",
  "MW": "CrosspostPublishNudge.module__dismissIcon___elgxZD",
};

module.exports = exports;
